export const FLIGHT_CONFIG_GET = "FLIGHT_CONFIG_GET";
export const FLIGHT_CONFIG_UPDATE = "FLIGHT_CONFIG_UPDATE";
export const FLIGHT_CONFIG_SUCCESS = "FLIGHT_CONFIG_SUCCESS";
export const FLIGHT_CONFIG_FAIL = "FLIGHT_CONFIG_FAIL";
